import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between pl-4 pr-1 py-1 fixed-top" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "nanum" }, "개발 DATA 확인", -1)
const _hoisted_3 = { class: "text-subtitle-1" }
const _hoisted_4 = { class: "text-caption ml-4" }
const _hoisted_5 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      icon: "terminal",
      theme: "dark",
      color: "grey-darken-4 text-grey-lighten-1",
      class: "floating-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$store.commit('toggleRightDrawer')))
    }),
    _createVNode(_component_v_navigation_drawer, {
      modelValue: _ctx.$store.state.rightDrawer,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.$store.state.rightDrawer) = $event)),
      theme: "dark",
      location: "right",
      "disable-resize-watcher": "",
      floating: false,
      permanent: "",
      width: "300"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_v_btn, {
            variant: "plain",
            size: "small",
            icon: "close",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$store.commit('toggleRightDrawer')))
          })
        ]),
        _createVNode(_component_v_expansion_panels, {
          variant: "accordion",
          class: "dev-tool-expansion"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (item, index) => {
              return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panel_title, null, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(item.title), 1),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(item.description), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_expansion_panel_text, { class: "pa-0 ma-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("pre", {
                        style: {"font-size":"12px","line-height":"1.2em","width":"100%","overflow-x":"auto"},
                        class: "text-secondary",
                        textContent: _toDisplayString(item.content)
                      }, null, 8, _hoisted_5)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}